module.exports = __webpack_public_path__ + "static/media/add-guarantor.5ccab98f.svg";